import axiosClient from '../axiosClient';

export const getUsers = (params) =>
  axiosClient.get('/admin/users', { params });

export const getUserDetail = (id) =>
  axiosClient.get(`/admin/users/${id}`);

export const updateUserStatus = (id, isActive) =>
  axiosClient.put(`/admin/users/${id}/status`, { isActive });

export const bulkUpdateUserStatus = (ids, isActive) =>
  axiosClient.put('/admin/users/bulk-status', { ids, isActive });

export const getUserTransactions = (id, params) =>
  axiosClient.get(`/admin/users/${id}/transactions`, { params });

export const deleteUser = (id) =>
  axiosClient.delete(`/admin/users/${id}`);
